import axios from 'axios';
import { apiBaseUrl, appRoutes } from 'utils';

const api = axios.create({
  baseURL: `${apiBaseUrl}/`,
  headers: {
    'Content-type': 'application/json',
  },
  maxBodyLength: Infinity,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refresh_token');
      if (!refreshToken) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        if (window.location.pathname !== appRoutes.login) {
          window.location.href = appRoutes.login;
        }
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(
          `${apiBaseUrl}/users/auth/refresh_token/`,
          { refresh: refreshToken }
        );
        const token = response.data.access;
        localStorage.setItem('access_token', token);
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return api(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('access_token');
        if (window.location.pathname !== appRoutes.login) {
          window.location.href = appRoutes.login;
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
